import { render, staticRenderFns } from "./ModifyBinEntity.vue?vue&type=template&id=fd559dd0&"
import script from "./ModifyBinEntity.vue?vue&type=script&lang=js&"
export * from "./ModifyBinEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports